import React from "react";

const HowWeHelp = ({ title, items }) => {
  return (
    <section className="section-spacing bg-light" id="how-we-help">
      <div className="container position-relative">
        <div className="small-container">
          <h2 className="fs-1 mb-5 lh-normal bold fst-normal text-uppercase">
            {title}
          </h2>
        </div>

        <div className="row pt-5">
          {items.map(({ imagePath, title, description }, index) => (
            <div className={`col-md-6 col-lg-4 mb-5 text-left`} key={index}>
              <img
                className="img-fluid mb-3 col-md-2"
                alt="alternative"
                src={imagePath}
              />
              <h4 className="fs-4 m-0 lh-normal semibold fst-normal mb-1">
                {title}
              </h4>
              <p className="opacity-75 fs-5">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeHelp;
